module.exports = __webpack_public_path__ + "img/xiaochengxu_2.13d83f43.png";